import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { OrderFormPageComponent } from './components/order-form-page/order-form-page.component';
import { OrderViewPageComponent } from './components/order-view-page/order-view-page.component';
import { OrdersPageComponent } from './components/orders-page/orders-page.component';
import { ClientsModule } from '../clients/clients.module';
import { EventsModule } from '../events/events.module';
import { OrderApiService } from './services/order-api/OrderApiService';

@NgModule({
  declarations: [OrderFormPageComponent, OrderViewPageComponent, OrdersPageComponent],
  imports: [CommonModule, FormsModule, RouterModule, ClientsModule, EventsModule],
  providers: [provideHttpClient(), OrderApiService],
  exports: [OrderFormPageComponent, OrderViewPageComponent, OrdersPageComponent],
})
export class OrdersModule { }
